import { AcceptGuestInvitationRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/accept-guest-invitation')({
  component: AcceptGuestInvitationRoute,
});
